module.exports = __webpack_public_path__ + "static/media/5.0c87241f.svg";